// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2od1T","subheader":"ReorderModal_subheader__vnLxj","listWrap":"ReorderModal_listWrap__2CTJF"};